export * from './baAmChart.component';



// WEBPACK FOOTER //
// /app/src/app/theme/components/baAmChart/index.ts